import React from 'react';

export default function CompetitionResultRequesterView() {
  return (
    <p>
      This ticket is only for WRT use. For any queries/requests, please message in
      the competition results email thread.
    </p>
  );
}
